package model

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import navigation.Navigation
import navigation.NavigationState
import ui.snackbars.SnackBarState

interface NavigationRepository {

    sealed class DialogState() {
        class Nothing() : DialogState()
        class LogOutConfirmation(val onConfirm: (Boolean) -> Unit) : DialogState()
        class CancelEnrollment(val onConfirm: (Boolean) -> Unit) : DialogState()
        class DeleteCard(val onConfirm: (Boolean) -> Unit) : DialogState()
    }

    val navigation: Navigation
    val navigationStateFlow: StateFlow<NavigationState>
    val backStackStateFlow: StateFlow<List<NavigationState>>

    val dialogStateMutableStateFlow: MutableStateFlow<DialogState>

    val snackbarStateMutableStateFlow: MutableStateFlow<SnackBarState>
    val snackbarStateStateFlow: StateFlow<SnackBarState>
    fun setSnackbarState(state: SnackBarState)

    fun navigate(navigationState: NavigationState)
    fun popBackStack()
    fun hashStateChangeEvent(newHash: String, locationListener: (String) -> Unit)
}